
import MHeader from '../Header/Header.vue';
import NotData from '../NoData/NoData.vue';
import XImg from 'vux/src/components/x-img/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Clocker from 'vux/src/components/clocker/index.vue'

import {
getGroupList
} from '../../api';
export default {
data() {
return {
list: ""
}
},
methods: {
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
}
},
components: {
MHeader,
XImg,
Clocker,
NotData

},
beforeRouteEnter: (to, from, next) => {
if (from.name == 'detail') {
next();
} else {
getGroupList().then(res => {
if (res.data.error) {
alert(res.data.msg);
console.error(res);
return;
};
console.log(res.data.data);
next(vm => {
vm.list = res.data.data;
});
});
}
},
filters: {
endTimer(val) {
return dateFormat(new Date(val * 1000), 'YYYY-MM-DD HH:mm:ss')
}
}
};



// WEBPACK FOOTER //
// ./src/components/HomeSpellGroup/HomeSpellGroup.vue